import src from "IMAGE";
export default { src, width: 984, height: 235, blurWidth: 0, blurHeight: 0};
